import { Modal, Title } from '@mantine/core';
import React from 'react';

import NotificationPreferencesComponent from './NotificationPreferences';

type NotificationPreferencesModalProps = {
  opened: boolean;
  onClose: () => void;
};

function NotificationPreferencesModal({
  opened,
  onClose,
}: NotificationPreferencesModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Title order={3}>Notification Preferences</Title>}
      size="lg"
    >
      <NotificationPreferencesComponent />
    </Modal>
  );
}

export default NotificationPreferencesModal;
